<script setup lang="ts">
import { RouterLink, useRoute } from 'vue-router';
import { LayoutDashboard, Kanban, Zap, BarChart3, ScanLine } from 'lucide-vue-next';

const route = useRoute();

type NavItem = { to: string; label: string; icon: typeof LayoutDashboard; primary?: boolean };
const items: NavItem[] = [
  { to: '/dashboard', label: 'Pulpit', icon: LayoutDashboard },
  { to: '/pipeline', label: 'Pipeline', icon: Kanban },
  { to: '/sales', label: 'Sprzedaz', icon: Zap, primary: true },
  { to: '/reports', label: 'Raporty', icon: BarChart3 },
  { to: '/scan', label: 'Skan', icon: ScanLine },
];
</script>

<template>
  <nav
    class="md:hidden fixed bottom-0 inset-x-0 z-30 backdrop-blur-xl border-t"
    :style="{
      background: 'var(--surface-bg-overlay)',
      borderColor: 'var(--border-soft)',
      paddingBottom: 'env(safe-area-inset-bottom, 0)',
    }"
  >
    <div class="flex items-center justify-around px-2 py-2">
      <RouterLink
        v-for="item in items"
        :key="item.to"
        :to="item.to"
        class="flex flex-col items-center gap-1 flex-1 py-1.5 px-2 rounded-card transition-all relative"
        :style="
          route.path === item.to
            ? { color: 'var(--surface-fg)' }
            : { color: 'var(--surface-fg-faint)' }
        "
      >
        <div
          v-if="item.primary"
          class="w-11 h-11 rounded-full flex items-center justify-center -mt-6 shadow-lg"
          :style="{
            background: 'var(--color-accent)',
            color: '#0E0E0E',
            boxShadow: '0 4px 16px rgba(0, 230, 118, 0.35)',
          }"
        >
          <component :is="item.icon" :size="20" />
        </div>
        <component v-else :is="item.icon" :size="20" />
        <span
          class="text-[10px] font-semibold uppercase tracking-wider"
          :class="{ 'mt-0.5': item.primary }"
        >
          {{ item.label }}
        </span>
        <span
          v-if="route.path === item.to && !item.primary"
          class="absolute -top-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full"
          :style="{ background: 'var(--color-accent)' }"
        ></span>
      </RouterLink>
    </div>
  </nav>
</template>
